import styles from "./styles.module.scss";
import { CoachingToolsItem } from "../Item";
import { CoachingToolsReviewItem } from "../ReviewItem";
import { FileChartColumnIncreasing, Star, Award } from "lucide-react";
import { VideoSidebar, PlayerBadgesModalMode } from "common/src/gamePage/types";
import { useStore as useGameStore } from "common/src/gamePage/store";
import { useStore as useEditStore } from "common/src/gamePage/edit-store";
import { _ } from "i18n";
import { useGetReviewsSummary } from "common/src/gamePage/hooks/useGetReviewsSummary";

export const CoachingToolsList = () => {
	const gameData = useGameStore((state) => state.gameData);
	const setSidebar = useGameStore((state) => state.setSidebar);
	const setPlayerRatingModal = useEditStore((state) => state.setPlayerRatingModal);
	const setPlayerBadgesModal = useEditStore((state) => state.setPlayerBadgesModal);
	const canAccessAiCoachReview = gameData?.permissions.showAiCoachReview === true;
	const { data } = useGetReviewsSummary({ enabled: canAccessAiCoachReview });

	if (gameData == null) {
		return null;
	}

	const canEditRatingsAndBadges = gameData.homeGameTeam.permissions.ratingBadgeEdit || gameData.awayGameTeam.permissions.ratingBadgeEdit;

	const handleTeamAndPlayerReviewsClick = () => {
		setSidebar(VideoSidebar.TeamPlayerReviews);
	};

	const handleRatePlayersClick = () => {
		setPlayerRatingModal({ show: true, id: 0, name: "", rating: null });
	};

	const handleAssignBadgesClick = () => {
		setPlayerBadgesModal({
			show: true,
			id: 0,
			name: "",
			badgeIds: [],
			mode: PlayerBadgesModalMode.Save,
		});
	};

	return (
		<div className={styles.list}>
			{canAccessAiCoachReview && (
				<CoachingToolsReviewItem
					name={_("game.coachingTools.list.teamAndPlayerReviews")}
					icon={FileChartColumnIncreasing}
					onClick={handleTeamAndPlayerReviewsClick}
					teamReview={data?.data ? { sent: data.data.teamReviewSent ? 1 : 0, total: 1 } : undefined}
					playerReviews={data?.data ? { sent: data.data.playerReviews.sent, total: data.data.playerReviews.total } : undefined}
				/>
			)}
			{canEditRatingsAndBadges && (
				<>
					<CoachingToolsItem name={_("game.coachingTools.list.ratePlayers")} icon={Star} onClick={handleRatePlayersClick} />
					<CoachingToolsItem name={_("game.coachingTools.list.assignBadges")} icon={Award} onClick={handleAssignBadgesClick} />
				</>
			)}
		</div>
	);
};
